// TODO: remove cast once types are regenerated post-deploy
// supabase.from('bags') uses `as any` because the bags table is not yet in auto-generated types.ts
import { useInfiniteQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useTenant } from '@/hooks/useTenant';
import type { BagFilter } from '../types';

const PAGE_SIZE = 20;

// PostgREST .or() interpola a string crua; neutraliza chars especiais do parser.
const escapeForOr = (s: string) => s.replace(/[,()*]/g, ' ').trim();

type UseBagsArgs = {
  filter: BagFilter;
  search: string;
};

export const useBags = ({ filter, search }: UseBagsArgs) => {
  const { tenant } = useTenant();
  const safeSearch = escapeForOr(search);

  return useInfiniteQuery({
    queryKey: ['bags', tenant?.id, filter, safeSearch],
    enabled: !!tenant?.id,
    initialPageParam: 0,
    getNextPageParam: (lastPage: unknown[], all: unknown[][]) =>
      lastPage.length < PAGE_SIZE ? undefined : all.length,
    queryFn: async ({ pageParam }) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let query = (supabase as any)
        .from('bags')
        .select('*, customers!inner(id, name, whatsapp, instagram, city, state), sales(id, total, payment_status, sale_items(quantity))')
        .eq('tenant_id', tenant!.id);

      if (filter === 'abertas') query = query.eq('status', 'aberta');
      if (filter === 'fechadas') query = query.eq('status', 'fechada').eq('label_generated', false);
      if (filter === 'etiqueta_gerada') query = query.eq('label_generated', true);

      if (safeSearch) {
        query = query.or(
          `name.ilike.%${safeSearch}%,whatsapp.ilike.%${safeSearch}%,instagram.ilike.%${safeSearch}%`,
          { foreignTable: 'customers' }
        );
      }

      const sortColumn = filter === 'abertas' ? 'opened_at' : 'closed_at';
      const sortAsc = filter === 'abertas';

      const start = (pageParam as number) * PAGE_SIZE;
      const { data, error } = await query
        .order(sortColumn, { ascending: sortAsc })
        .range(start, start + PAGE_SIZE - 1);

      if (error) throw error;
      return data ?? [];
    },
  });
};
